import camelize from 'camelcase-keys-deep';

export default class LotFile {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }

  document() {
    return this.env().Document.getById(this.documentId);
  }

  lot() {
    return this.env().Lot.getById(this.lotId);
  }
}
